
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./RemoteEntry": () => {
return __webpack_require__.e("61").then(() => (() => (__webpack_require__(652))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };